import { lighten } from 'polished';
import type { Colors, DefaultTheme } from 'styled-components';
import { setAlpha } from '../utils';
import { lightColors, mapLightTheme } from './LightTheme';
const colors: Colors = {
  ...lightColors,
};

const customButtonColor: Colors['green'] = {
  default: '#236092',
  lighten: lighten(0.1, '#236092'),
  dim: setAlpha(0.4, '#236092'),
  mute: setAlpha(0.1, '#236092'),
};

export const LightQ9Theme: DefaultTheme = mapLightTheme(colors, {
  name: 'Light',

  backgroundPositiveButton: customButtonColor.default,
  backgroundPositiveButtonHover: customButtonColor.lighten,
  backgroundPositiveButtonFocus: customButtonColor.lighten,
  backgroundPositiveButtonActive: customButtonColor.default,
  backgroundPositiveButtonDisabled: setAlpha(0.5, customButtonColor.default),
});
